import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface ActiveProjectState {
    activeByWorkspace: Record<string, string | null>;
    setActive: (workspaceId: string, projectId: string | null) => void;
    clearWorkspace: (workspaceId: string) => void;
}

export const useActiveProjectStore = create<ActiveProjectState>()(
    persist(
        (set) => ({
            activeByWorkspace: {},
            setActive: (workspaceId, projectId) =>
                set((state) => ({
                    activeByWorkspace: {
                        ...state.activeByWorkspace,
                        [workspaceId]: projectId,
                    },
                })),
            clearWorkspace: (workspaceId) =>
                set((state) => {
                    const next = { ...state.activeByWorkspace };
                    delete next[workspaceId];
                    return { activeByWorkspace: next };
                }),
        }),
        {
            name: "active-project",
            version: 2,
            migrate: (persisted) => {
                if (!persisted || typeof persisted !== "object") {
                    return { activeByWorkspace: {} };
                }
                const prev = persisted as { activeByWorkspace?: Record<string, string | null> };
                return { activeByWorkspace: prev.activeByWorkspace ?? {} };
            },
        },
    ),
);

export function useActiveProjectId(workspaceId: string | undefined): string | null {
    return useActiveProjectStore((s) => (workspaceId ? (s.activeByWorkspace[workspaceId] ?? null) : null));
}
